import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import APIConsumer from "../APIModel";
import { setAuthbytoken, setToken } from "../store/state/state";
import { useEffect, useState } from "react";
import errorExceptionSwitch from "../component/errorExceptionSwitch";

export default function ProtectedRoute() {
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.auth.token);
  const [err, setErr] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    APIConsumer.getMe(token)
      .then((res) => {
        const url = errorExceptionSwitch(res.status);
        if (url.success) {
          dispatch(setAuthbytoken(res.body));
        } else {
          dispatch(setToken(""));
        }
      })
      .then(() => {
        setLoading(false);
      });
  }, [token]);
  if (err) {
    return <Navigate to="/error" />;
  }
  if (!token) {
    return <Navigate to="/login" />;
  }

  if (loading) return <h1>loading...</h1>;
  return <Outlet />;
}
